export var toggleCheckboxOff = [
    'M12.13 2.75H3.88C3.24 2.75 2.75 3.27 2.75 3.88V12.13C2.75 12.76 3.24 13.25 3.88 13.25H12.13C12.73 13.25 13.25 12.76 13.25 12.13V3.88C13.25 3.27 12.73 2.75 12.13 2.75ZM12.5 12.13C12.5 12.34 12.31 12.5 12.13 12.5H3.88C3.66 12.5 3.5 12.34 3.5 12.13V3.88C3.5 3.69 3.66 3.5 3.88 3.5H12.13C12.31 3.5 12.5 3.69 12.5 3.88V12.13Z',
];
